var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconComboBasket = function SvgIconComboBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    fill: "none",
    viewBox: "0 0 18 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "M2 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 19V7q0-.824.588-1.412A1.93 1.93 0 0 1 2 5h2q0-2.075 1.463-3.537Q6.925 0 9 0t3.537 1.463T14 5h2q.824 0 1.413.588Q18 6.175 18 7v12q0 .824-.587 1.413A1.93 1.93 0 0 1 16 21zm7-8q2.075 0 3.537-1.463Q14 10.075 14 8h-2q0 1.25-.875 2.125A2.9 2.9 0 0 1 9 11a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 6 8H4q0 2.075 1.463 3.537Q6.925 13 9 13M6 5h6q0-1.25-.875-2.125A2.9 2.9 0 0 0 9 2q-1.25 0-2.125.875A2.9 2.9 0 0 0 6 5"
  })));
};
export default SvgIconComboBasket;